import { sendOrderDetailEmail, sendOrderDetailSMS, shareOrderDetailUrl } from "@/store/modules/graphql";
import createApolloClient from "@/api/appollo";

export function sendEmail(orderCode) {
  return createApolloClient.query({
    query: sendOrderDetailEmail,
    variables: {
      orderCommonInput: { orderCode }
    }
  });
}

export function sendSMS(orderCode) {
  return createApolloClient.query({
    query: sendOrderDetailSMS,
    variables: {
      orderCommonInput: { orderCode }
    }
  });
}

export function handleShare(orderCode) {
  return createApolloClient.query({
    query: shareOrderDetailUrl,
    variables: {
      orderCommonInput: { orderCode }
    }
  });
}
